import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import WaveSurfer from 'wavesurfer.js';
import CursorPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js';
import { is768Query } from '~/core/scripts/mediaquery-helper';


import WaveVizControls from './Controls';
import './WaveViz.styl';

class WaveViz extends PureComponent {

  static propTypes = {
    audioSrc: PropTypes.string.isRequired,
    waveColor: PropTypes.string,
    progressColor: PropTypes.string,
    cursorColor: PropTypes.string,
    cursorWidth: PropTypes.number,
    height: PropTypes.number,
    showMuteButton: PropTypes.bool,
    isMuted: PropTypes.bool
  }

  static defaultProps = {
    waveColor: '#474747',
    progressColor: '#797979',
    cursorColor: '#AAAAAA',
    cursorWidth: 1,
    height: !is768Query() ? 80 : 120,
    showMuteButton: false,
    isMuted: false
  }

  state = {
    isPlaying: false,
    isLoading: true,
    isMuted: false
  }

  componentDidMount() {
    this.wavesurfer = WaveSurfer.create(this.getWavesurferOptions());

    this.wavesurfer.on('ready', this.onWaveSurferReady);
    this.wavesurfer.on('finish', this.onWaveSurferFinish);
    this.wavesurfer.load(this.props.audioSrc);

    this.handleInitMute();
  }

  getWavesurferOptions() {
    return ({
      container: this.waveform,
      waveColor: this.props.waveColor,
      progressColor: this.props.progressColor,
      cursorColor: this.props.cursorColor,
      height: this.props.height,
      responsive: true,
      normalize: true,
      plugins: [CursorPlugin.create({ color: '#eee' })]
    });
  }

  handleInitMute() {
    if (this.props.isMuted) {
      this.wavesurfer.setMute(true);
      this.setState({ isMuted: true });
    }
  }

  onWaveSurferReady = () => {
    this.setState({ isLoading: false });
  }

  onWaveSurferFinish = () => {
    window.setTimeout(() => {
      this.setState({ isPlaying: false });
      this.wavesurfer.seekTo(0)
    }, 150);
  }

  togglePlay = () => {
    if (this.state.isLoading) {
      return false;
    }

    this.wavesurfer.playPause();

    this.setState({
      isPlaying: !this.state.isPlaying
    });
  }

  toggleMute = () => {
    if (this.state.isLoading) {
      return false;
    }

    this.wavesurfer.toggleMute();

    this.setState({
      isMuted: !this.state.isMuted
    });
  }

  render() {
    const { showMuteButton } = this.props;
    const { isPlaying, isMuted } = this.state;

    return (
      <div className="waveviz">
        <WaveVizControls
          showMuteButton={showMuteButton}
          isPlaying={isPlaying}
          isMuted={isMuted}
          toggleMute={this.toggleMute}
          togglePlay={this.togglePlay}
        />
        <div className="waveviz__viz" ref={ref => { this.waveform = ref; }} />
      </div>
    );
  }
}

export default WaveViz;